import { AxiosResponse } from "axios";

// Api's
import { api } from "./base/api";
import { IQuoteAttachmentApi } from "./base";

// Models
import { Result } from "../models/common/resultResponse";
import { DeleteQuoteAttachmentRequest, SaveQuoteAttachmentsRequest } from "../models/request";
import { TimeoutRequestConfigurationEnum } from "../services/enum/TimeoutRequestConfigurationEnum";

const baseRoute: string = "QuoteAttachment";

export class QuoteAttachmentApi extends IQuoteAttachmentApi {
	saveAttachments(request: SaveQuoteAttachmentsRequest): Promise<AxiosResponse<Result<boolean>>> {
		const formData = new FormData();
		formData.append("QuoteGuid", request.quoteGuid);

		request.attachmentsRequest.forEach((attachment, index) => {
			formData.append(`AttachmentsRequest[${index}].FileUpload`, attachment.file);
			formData.append(`AttachmentsRequest[${index}].Comment`, attachment.comment ?? "");
			formData.append(`AttachmentsRequest[${index}].QuoteItemGuid`, attachment.quoteItemGuid ?? "");
		});

		return api.post(`${baseRoute}/save`, formData, {
			timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds,
		});
	}

	deleteAttachment(request: DeleteQuoteAttachmentRequest): Promise<AxiosResponse<Result<boolean>>> {
		return api.delete(`${baseRoute}/delete`, { params: request });
	}
}
